import React from 'react';
import { APIProvider, Map } from '@vis.gl/react-google-maps';
import { useInstantSearch, Configure } from 'react-instantsearch';
import SearchMapContent from './SearchMapContent';

const GOOGLE_MAPS_API_KEY = 'AIzaSyDHeASGVySF_J2T1ctEiAkVUdv9oBCgKjI';
const SPAIN_CENTER = { lat: 40.4637, lng: -3.7492 };
const DEFAULT_ZOOM = 6;

const SearchMap = () => {
    const { results } = useInstantSearch();

    return (
        <div style={{ width: '100%', height: '70vh' }}>
            <Configure hitsPerPage={1000} />
            <APIProvider
                apiKey={GOOGLE_MAPS_API_KEY}
                libraries={['places', 'geometry']}
            >
                <Map
                    mapId="8f541c90bb5b58e2"
                    defaultCenter={SPAIN_CENTER}
                    defaultZoom={DEFAULT_ZOOM}
                    disableDefaultUI={false}
                    options={{
                        mapTypeControl: false,
                        fullscreenControl: false,
                        zoomControl: true,
                        streetViewControl: false,
                        scaleControl: true,
                        draggable: true,
                        gestureHandling: 'cooperative',
                        clickableIcons: false,
                    }}
                >
                    <SearchMapContent hits={results.hits} />
                </Map>
            </APIProvider>
        </div>
    );
};

export default SearchMap;